import { BaseDialog } from './BaseDialog';
import { useTranslation } from '../../store';
import { isValueEmpty } from '../../services/utils';

export const AlertDialog = ({ 
  isOpen, 
  onClose,
  onConfirm,
  onCancel,
  titleKey = 'alertTitle',
  closeKey = 'buttons.close',
  confirmKey = 'buttons.confirm',
  message
}) => {
  const { t } = useTranslation();
    
  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };
  
  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  const hasConfirm = () => {
    if (!isValueEmpty(onConfirm)) {
        return true;
    }
    return false;
  };

  return (
    <BaseDialog isOpen={isOpen} onClose={handleCancel} title={t(titleKey)} size="sm">
      <p>{message}</p>
      <div className="spacer"></div>
      <hr></hr>
      <div className="d-flex justify-content-end gap-2 pt-3 border-top">
        <button type="button" className="btn btn-outline-secondary" onClick={handleCancel}>{t(closeKey)}</button>
        {hasConfirm() && (
            <>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <button type="button" className="btn btn-outline-primary" onClick={handleConfirm}>{t(confirmKey)}</button>
            </>
        )}
      </div>
    </BaseDialog>
  );
};